export enum Role {
  SUPERUSER = 0,
	SUPER_AMT = 1,
	RESEARCHER = 2,
	SENIOR_AMT = 3,
	AMT = 4,
	UKB_REVIEWER = 5,
	ETHOX = 6,
	EGC = 7,
	SYSTEM_ADMIN = 8,
	TEST = 9,
	OBSERVER = 10,
	BACKGROUND_PROCESSOR = 99
}